(() => {
  if (window.__TMP_2PLUS1_CAMPAIGN_V2__) return;
  window.__TMP_2PLUS1_CAMPAIGN_V2__ = true;

  const state = {
    shadeHandles: null,
    cart: null,
    shadeQty: 0,
    saving: 0,
    cartTimer: null,
    pdpTimer: null,
    startedTracked: false
  };

  const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ');
  const isPromoProduct = () => Boolean(document.querySelector('[data-tmp-bundle-root], [data-tmp-bundle-template]'));

  const formatMoney = (cents) => {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-NL', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
        minimumFractionDigits: amount % 1 ? 2 : 0,
        maximumFractionDigits: amount % 1 ? 2 : 0
      }).format(amount);
    } catch (_) {
      return `€${amount.toFixed(amount % 1 ? 2 : 0)}`;
    }
  };

  const track = (eventName, data = {}) => {
    const payload = { ...data, campaign: 'buy_2_get_1_free' };
    window.dispatchEvent(new CustomEvent(`tmp:${eventName}`, { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: eventName, ...payload });
    if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, payload);
  };

  const findLeaf = (root, values) => {
    const targets = (Array.isArray(values) ? values : [values]).map(normalize);
    return Array.from(root?.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,strong,a,button,summary,div') || [])
      .find((node) => node.children.length === 0 && targets.includes(normalize(node.textContent)));
  };

  const markPromoProduct = () => {
    const active = isPromoProduct();
    document.body.classList.toggle('tmp-2plus1-product', active);
    return active;
  };

  async function loadShadeHandles() {
    if (state.shadeHandles) return state.shadeHandles;
    try {
      const response = await fetch('/collections/all-shades/products.json?limit=250', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load shade collection');
      const json = await response.json();
      state.shadeHandles = new Set((json.products || []).map((product) => product.handle).filter(Boolean));
    } catch (_) {
      state.shadeHandles = new Set();
    }
    return state.shadeHandles;
  }

  const namedDiscountSaving = (item) => {
    const allocations = item.line_level_discount_allocations || item.discounts || [];
    return allocations.reduce((sum, allocation) => {
      const title = allocation.discount_application?.title || allocation.title || '';
      return normalize(title).toUpperCase() === 'MEMBER' ? sum + (Number(allocation.amount) || 0) : sum;
    }, 0);
  };

  const lineSaving = (item) => Math.max(0, (Number(item.original_line_price) || 0) - (Number(item.final_line_price) || 0));

  async function fetchCartState() {
    const handles = await loadShadeHandles();
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    const cart = await response.json();
    const shadeItems = (cart.items || []).filter((item) => handles.has(item.handle));
    const shadeQty = shadeItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    const namedSaving = shadeItems.reduce((sum, item) => sum + namedDiscountSaving(item), 0);
    const derivedSaving = shadeQty >= 3 ? shadeItems.reduce((sum, item) => sum + lineSaving(item), 0) : 0;
    const saving = Math.max(namedSaving, derivedSaving);
    Object.assign(state, { cart, shadeQty, saving });
    return { cart, shadeItems, shadeQty, saving };
  }

  const setHidden = (element, hidden) => {
    if (!element) return;
    element.classList.toggle('tmp-campaign-hidden', Boolean(hidden));
  };

  const renderCartBanner = (drawer, cartState) => {
    const header = drawer.querySelector('.cart-drawer__header');
    const heading = header?.querySelector('.drawer__heading');
    let banner = header?.querySelector('.tmp-campaign-cart-status');
    if (!heading || cartState.shadeQty <= 0) {
      banner?.remove();
      return;
    }
    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'tmp-campaign-cart-status';
      heading.after(banner);
    }

    let title = '';
    let cta = '';
    if (cartState.shadeQty === 1) {
      title = '1/3 SELECTED — ADD 2 MORE';
      cta = '<a class="tmp-campaign-cart-status__cta" href="/collections/all-shades">SHOP SHADES →</a>';
    } else if (cartState.shadeQty === 2) {
      title = '2/3 SELECTED — ADD 1 MORE';
      cta = '<a class="tmp-campaign-cart-status__cta" href="/collections/all-shades">ADD 1 MORE SHADE →</a>';
    } else {
      title = '3 SHADES ADDED ✓';
    }

    const markup = `<span>BUY 2 GET 1 FREE</span><strong>${title}</strong><small>Automatic — no code needed</small>${cta}`;
    if (banner.innerHTML !== markup) banner.innerHTML = markup;
    banner.classList.toggle('is-applied', cartState.shadeQty >= 3);
  };

  const applyCartUi = (cartState) => {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer || !cartState) return;
    renderCartBanner(drawer, cartState);

    const campaignCart = cartState.shadeQty > 0;
    setHidden(drawer.querySelector('free-shipping-goal'), campaignCart);
    drawer.querySelectorAll('[aria-controls^="CartDiscount-"], [id^="CartDiscount-"], foxkit-incart-upsell, .cart-drawer-products-recommendation')
      .forEach((element) => setHidden(element, campaignCart));

    drawer.querySelectorAll('.discount span, .cart-item__discounts span').forEach((element) => {
      if (normalize(element.textContent).toUpperCase() === 'MEMBER') element.textContent = '2+1 APPLIED';
    });

    cartState.shadeItems.forEach((item) => {
      const discounted = namedDiscountSaving(item) > 0 || (cartState.shadeQty >= 3 && lineSaving(item) > 0);
      if (!discounted) return;
      const line = drawer.querySelector(`.cart-item[data-variant-id="${item.variant_id}"]`);
      if (!line) return;
      line.classList.add('tmp-campaign-discounted-item');
      if (Number(item.final_line_price) === 0 && Number(item.original_line_price) > 0) {
        const finalPrice = line.querySelector('.cart-item__prices .price__regular');
        if (finalPrice) finalPrice.textContent = 'FREE';
      }
    });
  };

  async function refreshCart() {
    try {
      const cartState = await fetchCartState();
      if (cartState) applyCartUi(cartState);
    } catch (_) {}
  }

  const scheduleCartRefresh = (delay = 120) => {
    window.clearTimeout(state.cartTimer);
    state.cartTimer = window.setTimeout(refreshCart, delay);
  };

  const optimizePdp = () => {
    if (!markPromoProduct()) return;
    const main = document.querySelector('#MainContent');
    if (!main) return;

    const productSection = main.querySelector('product-info')?.closest('.shopify-section');
    const bestsellerSection = main.querySelector('.tmp-home-bestsellers-row')?.closest('.shopify-section');
    const ugcHeading = findLeaf(main, ['LOVED BY 10K+ CUSTOMERS', 'SEE IT ON', 'HOW TO STYLE THEM']);
    const ugcSection = ugcHeading?.closest('.shopify-section');

    if (ugcHeading && normalize(ugcHeading.textContent) !== 'SEE IT ON') ugcHeading.textContent = 'SEE IT ON';
    const ugcSubheading = ugcSection && findLeaf(ugcSection, [
      'Real people. Real reviews. Real love.',
      'Real people. Real shades. 10K+ customers.',
      'Certified Members'
    ]);
    if (ugcSubheading && normalize(ugcSubheading.textContent) !== 'Real people. Real shades. 10K+ customers.') {
      ugcSubheading.textContent = 'Real people. Real shades. 10K+ customers.';
    }

    if (productSection && ugcSection && productSection.nextElementSibling !== ugcSection) productSection.after(ugcSection);
    if (ugcSection && bestsellerSection && ugcSection.nextElementSibling !== bestsellerSection) ugcSection.after(bestsellerSection);

    const shipping = findLeaf(main, ['Free shipping over €100', 'Worldwide shipping']);
    if (shipping) shipping.textContent = 'Free shipping on orders over €100';
    const returns = findLeaf(main, 'Easy returns');
    if (returns) returns.textContent = '14-day returns';
    const member = findLeaf(main, 'Become a member');
    if (member) member.textContent = '10,000+ customers';

    const faqQuestion = findLeaf(main, 'I have a discount code, how do I use it?');
    if (faqQuestion) {
      faqQuestion.textContent = 'How does Buy 2 Get 1 Free work?';
      const paragraph = Array.from(faqQuestion.closest('details')?.querySelectorAll('p') || [])
        .find((node) => /discount code/i.test(node.textContent));
      if (paragraph) paragraph.textContent = 'Add 3 shades to your cart. The offer applies automatically — no code needed.';
    }
  };

  const schedulePdp = (delay = 40) => {
    window.clearTimeout(state.pdpTimer);
    state.pdpTimer = window.setTimeout(optimizePdp, delay);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-tmp-bundle-root] .tmp-meller-card__choose') && !state.startedTracked) {
      state.startedTracked = true;
      track('2plus1_started');
    }
    if (event.target.closest?.('button[name="checkout"]')) {
      track('checkout_started', {
        cart_value: state.cart ? formatMoney(state.cart.total_price) : undefined,
        shade_quantity: state.shadeQty
      });
    }
  });

  document.addEventListener('tmp:second_pair_selected', (event) => track('second_pair_selected', event.detail || {}));
  document.addEventListener('tmp:free_pair_selected', (event) => track('free_pair_selected', event.detail || {}));
  document.addEventListener('tmp:bundle_added', () => {
    track('bundle_added');
    scheduleCartRefresh(100);
    window.setTimeout(refreshCart, 380);
  });

  ['cart:updated', 'cart:refresh', 'product-ajax:added'].forEach((name) => {
    document.addEventListener(name, () => {
      scheduleCartRefresh(name === 'cart:updated' ? 50 : 140);
      window.setTimeout(refreshCart, 380);
    });
  });

  document.addEventListener('shopify:section:load', () => {
    schedulePdp(40);
    scheduleCartRefresh(120);
  });
  document.addEventListener('shopify:section:reorder', () => schedulePdp(40));
  document.addEventListener('shopify:block:select', () => schedulePdp(40));

  const init = () => {
    markPromoProduct();
    scheduleCartRefresh(40);
    optimizePdp();
    window.setTimeout(optimizePdp, 220);
    if (document.body.classList.contains('page-template') && document.body.classList.contains('2plus1')) track('2plus1_landing_view');
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
